import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'

const ArrowBack = require('assets/components/arrow-back.svg')
const styles = require('./styles')

export interface BackButtonProps {
  className?: string
  onClick: () => void
}

export const BackButton: React.FC<BackButtonProps> = ({ className, onClick }) => (
  <ThemeConsumer>
    {({ colorPrimary, colorTextPrimary, fontFamilyPrimary }) => (
      <div
        data-test-id="backButton"
        className={classnames(
          styles.backButton,
          css`
            color: ${colorPrimary};
            font-family: ${fontFamilyPrimary};
            svg path {
              fill: ${colorPrimary};
            }
            &:hover {
              color: ${colorTextPrimary};
              svg path {
                fill: ${colorTextPrimary};
              }
            }
          `,
          className,
        )}
        onClick={onClick}
      >
        <ArrowBack /> Back
      </div>
    )}
  </ThemeConsumer>
)
